import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const InvoiceChangeInvoiceModifiersDialogTourConfig: AgTechTourConfig = {
    id: 'invoice-change-invoice-modifiers-dialog-tour',
    name: 'Update Charges and Discounts Tour',
    steps: [
        {
            targetId: 'invoice-change-modifiers-summary',
            title: 'Invoice Math',
            description: 'Lots sold, less charges and discounts, less credits applied, equals the invoice amount. It updates live as you change the selection.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-change-modifiers-grid',
            title: 'Charges and Discounts',
            description: 'Select the sale-level charges (like fees) and discounts that apply to this invoice. Click Submit to save.',
            position: 'top',
        },
    ]
}
